import { IUpdateSclaPrompts, SclaApplication } from 'features/scla/types';
import { makePutRequest } from 'lib/axios';

const updateSclaAppPrompts = async (
  id: string,
  payload: IUpdateSclaPrompts,
): Promise<SclaApplication> => {
  const url = `/scla/application/prompts/${id}`;
  const response = await makePutRequest(url, payload);
  return response.data.payload;
};

export default updateSclaAppPrompts;
